<div class="col-12">
  <nav class="menu">
    <div class="smartphone-menu-trigger"></div>
    <header class="side-avtar">
      <img src="./assets/images/logo.png" class="img-fluid" alt="..." />
    </header>
    <ul class="njstep">
      <ng-container *ngFor="let step of getVisibleSteps(); let i = index">
        <a (click)="moveTo(step.id)">
          <li class="icon">
            <div class="num" [ngClass]="'num' + step.id + (currentStep > step.id ? ' white-background' : '')">
              <span *ngIf="!isCompleted(step.id)">{{ i + 1 }}</span>
              <i *ngIf="isCompleted(step.id)" class="fas fa-check"></i>
            </div>
            <span>{{ step.label }}</span>
          </li>
        </a>
      </ng-container>
    </ul>
  </nav>
</div>
